export enum TrainEventRecordView {
    Overview,
    TrainEventRecord
}
export enum TrainView {
    MyForm,
    Overview
}